import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { updateModal } from '../../../store/common/common_action'
import {
  getReceiveUpdateReceive,
  getReceiveShortReceive,
  getUpdateReceiveSecond,
  getReceiveLastReceivePrint,
  getReceiveUpdateReceiveAllV2,
} from '../../../store/branchTransferReceive/branchReceive_action'
import LineInput from '../../common/lineinput'
import * as error from '../../common/error_strings'
import { Item } from '../../common/snippets'
import { clickElement, dateFormatWithInputData, focusElemnt, navigation3 } from '../../common/helper'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontNirmalaNormal } from '../BranchTransfer/fonts/Nirmala-normal'
import { callAddFontNirmalaBold } from '../BranchTransfer/fonts/Nirmala-bold'
import Modal from '../../common/modal'
import ReceivedItem from './ReceivedItem'
import { GUJRAT_COMPANY_ID, JAIN_COMPANY_ID, JAIN_NEW, RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { ChallanListAtom, LITReceiveAtom, receiveFilteredTableRowsAtom, receiveFilteredTableSourceAtom, receiveLITLrListAtom, receiveLrListAtom, selectChallanAtom, showListAllAtom } from '../../common/jotaiState/receiveStateAtoms'
import { PostRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { alertAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import { groupData } from '../Reports/userWiseCollReport/utilFucntions'
import { fetchInsertReceiveAllAtom, fetchInsertReceiveAtom, receiveMemoResultAtom, receivePrintPopupAtom } from '../../common/jotaiState/dispatchStateAtoms'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'

const ReceiveBottomSection = ({
  getReceiveUpdateReceive,
  getReceiveUpdateReceiveAllV2,
  getReceiveShortReceive,
  updateModal,
  getReceiveLastReceivePrint,
  data,
  topSelectedData,
  tSecDropData,
  selectedData,
  setTSecDropData,
  indexSetState,
  setTopSelectedData,
  setSelectedData,
  setShowBtnList,
  handleAlert,
  setResetFlag,
  resetFlag,
  selelectedData
}) => {
  const { common, BranchTransferReceiveReducer } = data
  const { strtCity, loginData, strtBrnch, loader, modalType, showModal, roleRights } = { ...common }
  const { receiveReceive, receiveShortReceive, receiveSecond, receiveLastReceivePrint } = { ...BranchTransferReceiveReducer }
  const [receiveListData] = useAtom(receiveLrListAtom)
  const [LITReceive,setLITReceive] = useAtom(LITReceiveAtom)
  const [, setReceiveLITLrList] = useAtom(receiveLITLrListAtom)
  const [, setInsertReceive] = useAtom(fetchInsertReceiveAtom)
  const [, setChallanList] = useAtom(ChallanListAtom)
  const [showListAll,setShowListAll]=useAtom(showListAllAtom)
  const [receiveMemoResult, setReceiveMemoResult] = useAtom(receiveMemoResultAtom)
  const [receivePrintPopup, setReceivePrintPopup] = useAtom(receivePrintPopupAtom)
  const [, setInsertReceiveAll] = useAtom(fetchInsertReceiveAllAtom)
  const [selectedChallan, setSelectedChallan] = useAtom(selectChallanAtom)
  const [filteredTableRows] = useAtom(receiveFilteredTableRowsAtom)
  const [filteredTableSource] = useAtom(receiveFilteredTableSourceAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const { ReceiveChallanPortrait } = companySettings
  
  
  
  const [, setAlert] = useAtom(alertAtom)
  const [modal,setModal] = useAtom(modalAtom)
  
  const [successModal, setSuccessModal] = useState({
    Receive: { id: 'Receive', lrListLabel: 'Receive popup modal', isSaved: false },
    ShortReceive: { id: 'ShortReceive', lrListLabel: 'Short Receive popup modal', isSaved: false },
    ReceiveSuccess: { id: 'ReceiveSuccess', lrListLabel: 'Receive Success popup modal', isSaved: false },
    ShortReceiveSuccess: { id: 'ShortReceiveSuccess', lrListLabel: 'Short Success Receive popup modal', isSaved: false },
    LastReceivePrint: { id: 'LastReceivePrint', lrListLabel: 'Last Receive Print popup modal', isSaved: false },
    ReceivedItemList: { id: 'ReceivedItemList', lrListLabel: 'Received Item List popup modal', isSaved: false },
  })
  const [selectedPrintData, setSelectedPrintData] = useState(null)
  const [filteredPreviewPdfUrl, setFilteredPreviewPdfUrl] = useState('')
  const [state, setState] = useState({
    Remarks: '',
    LrNo: [],
    BookingId: [],
    shortQtys: [],
    damageQtys: [],
    DipatchIDs: [],
    DispatchDetIDs: [],
    load: false,
    generatePDF: false,
    filteredPreviewGeneratePDF: false,
    received: false,
    lastReceivePrint: false,
    dFromBranchForPrint: '',
  })
  const {
    Remarks,
    LrNo,
    BookingId,
    shortQtys,
    damageQtys,
    DipatchIDs,
    DispatchDetIDs,
    load,
    generatePDF,
    filteredPreviewGeneratePDF,
    received,
    dFromBranchForPrint,
    lastReceivePrint,
  } = state
  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }
  // All UseEffect
  useEffect(() => {
    if (receivePrintPopup) {
      getReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All' })
      setSelectedChallan({})
      setState({ ...state, Remarks: '' })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      if (topSelectedData.DFromCity != null) {
        clickElement('BranchReceiveFromCity')
      } if (topSelectedData.DFromBranch != null) {
        clickElement('BranchReceiveFromBranch')
      } if (topSelectedData.SelectedVehicle !== '') {
        clickElement('BranchreceiveVehicleCross')
      }
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
        LRNO: '',
      })
      setLITReceive(0)
      setSelectedData([])
      setChallanList([])
      setShowBtnList(true)
    }
  }, [receivePrintPopup])

  useEffect(() => {
    if (selectedData?.length >= 1) {
      const lr = selectedData?.map((item) => item.LRNO)
      const bookingid = selectedData?.map((item) => item.BookingID)
      const DipatchIDs = selectedData?.map((item) => item.DispatchID)
      const dispatchDetIDs = selectedData?.map((item) => item.DispatchDetID)
      const ShortQtys = selectedData.map((item) => 0)
      const DamageQtys = selectedData.map((item) => 0)

      setState({
        ...state,
        LrNo: lr,
        shortQtys: ShortQtys,
        damageQtys: DamageQtys,
        DispatchDetIDs: dispatchDetIDs,
        DipatchIDs: DipatchIDs,
        BookingId: bookingid,
      })
    } else {
      setState({
        ...state,
        LrNo: [],
        shortQtys: [],
        damageQtys: [],
        DipatchIDs: [],
        DispatchDetIDs: [],
      })
    }
  }, [selectedData])

  useEffect(() => {
    if (showModal && modalType === 'FilteredTablePreview' && filteredPreviewGeneratePDF) {
      generateFilteredTablePreviewPdf()
    }
  }, [showModal, modalType, filteredPreviewGeneratePDF])

  useEffect(() => {
    if (receiveReceive?.status === 'Success') {
      getReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All' })
      setSelectedChallan({})
      setState({ ...state, Remarks: '' })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
      })
      setLITReceive(0)
      clickElement('BranchReceiveFromCity')
      clickElement('BranchReceiveFromBranch')
      clickElement('BranchreceiveVehicleCross')
      setSelectedData([])
      setChallanList([])
      setShowBtnList(true)
    } else {
      handleAlert(receiveSecond?.ErrMessage)
    }
  }, [receiveReceive])
  useEffect(() => {
    if (receiveShortReceive.status === 'Success') {
      updateModal(true, 'ShortReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', })
      setState({ ...state, Remarks: '' })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
      })
      setLITReceive(0)
      clickElement('BranchReceiveFromCity')
      clickElement('BranchReceiveFromBranch')
      clickElement('BranchreceiveVehicleCross')
      setSelectedData([])
      setSelectedChallan({})
      setChallanList([])
      setShowBtnList(true)
    } else {
      handleAlert(receiveSecond?.ErrMessage)
    }
  }, [receiveShortReceive])
  //All useEffect End
  const formatPreviewDate = (value) => {
    if (!value) return ''
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : value
  }

  const getFilteredTablePreviewColumns = () => {
    const columns = [
      { exportHead: 'SN', field: 'srNo' },
      { exportHead: 'LR No.', field: 'LRNO' },
      { exportHead: 'Manual LR', field: 'ManualLRNo' },
      { exportHead: 'Booking Date', field: 'BookingDateTime' },
      { exportHead: 'Cons. Type', field: 'DescriptionDet' },
      { exportHead: 'Pay. Type', field: 'PaymentType' },
      { exportHead: 'Units', field: 'Quantity' },
      { exportHead: 'Sender', field: 'Sender' },
      { exportHead: 'Receiver', field: 'RecName' },
      { exportHead: 'Source', field: 'FromCity' },
      { exportHead: 'Destination', field: 'ToCity' },
      { exportHead: 'Challan', field: 'ChallanNo' },
      loginData?.intCompanyID !== RAJESH_TRANSPORT && { exportHead: 'Gross Amount', field: 'NetAmount' },
    ]

    return columns.filter(Boolean)
  }

  const getFilteredTablePreviewRows = () => {
    let totalUnits = 0
    let totalAmount = 0

    const rows = (filteredTableRows || []).map((item, index) => {
      const quantity = Number(item?.Quantity || 0)
      const amount = Number(item?.NetAmount || 0)
      totalUnits += quantity
      totalAmount += amount

      return {
        srNo: index + 1,
        LRNO: item?.LRNO || '',
        ManualLRNo: item?.ManualLRNo || '',
        BookingDateTime: formatPreviewDate(item?.BookingDateTime),
        DescriptionDet: item?.ConsignmentData?.length === 1 ? item?.DescriptionDet || '' : 'Multi',
        PaymentType: item?.PaymentType || '',
        Quantity: quantity,
        Sender: item?.Sender || '',
        RecName: item?.RecName || '',
        FromCity: item?.FromCity || '',
        ToCity: item?.ToCity || '',
        ChallanNo: item?.ChallanNo || '',
        NetAmount: amount,
      }
    })

    rows.push({
      srNo: 'Total',
      Quantity: totalUnits,
      NetAmount: totalAmount,
    })

    return rows
  }

  const generateFilteredTablePreviewPdf = (isSave = false) => {
    if (!filteredTableRows?.length) {
      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
      updateModal(false)
      handleAlert('No filtered receive rows found')
      return
    }

    jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])

    const pdfColumns = getFilteredTablePreviewColumns().map((col) => ({
      header: col.exportHead,
      dataKey: col.field,
    }))
    const previewRows = getFilteredTablePreviewRows()
    const doc = new jsPDF({
      unit: 'px',
      compress: true,
      orientation: pdfColumns.length > 10 ? 'l' : 'p',
    })

    const totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Receive Filter Preview.pdf`,
      subject: 'Receive Filter Preview',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 24, left: 8, right: 8, bottom: 10 },
      columns: pdfColumns,
      body: previewRows,
      theme: 'grid',
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [30, 89, 167],
        fontSize: 7,
      },
      bodyStyles: {
        font: 'Nirmala',
        fontSize: 7,
      },
      didParseCell: (data) => {
        if (data.row.raw?.srNo === 'Total') {
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.fillColor = [208, 220, 238]
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 8, 8, 10, 10)
        doc.setFontSize(12)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Receive Filter Preview', 20, 15)
        doc.setFontSize(9).setFont(undefined, 'bold')
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 15, 'right')
        doc.setFont('Nirmala', 'normal')
 

        const pageHeight = doc.internal.pageSize.height ? doc.internal.pageSize.height : doc.internal.pageSize.getHeight()
        const pageWidth = doc.internal.pageSize.width ? doc.internal.pageSize.width : doc.internal.pageSize.getWidth()
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.2)
        doc.line(0, pageHeight - 8, pageWidth, pageHeight - 8)
        let pageText = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          pageText = pageText + ' of ' + totalPagesExp
        }
        doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 8, pageHeight - 2)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 190, pageHeight - 2)
        doc.text(pageText, pageWidth - 70, pageHeight - 2)
      },
    })

    doc.setFont('Nirmala')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    const pdfUrl = doc.output('bloburl')
    setFilteredPreviewPdfUrl(pdfUrl)

    if (isSave) {
      doc.save(`Receive Filter Preview ${moment(new Date()).format('DD-MMM-YYYY HH-mm')}.pdf`)
    }

    setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
  }

  const printClick = () => {
    const updateData = [...receiveMemoResult]
    // if (selectedPrintData == null) {
    if (receiveMemoResult === undefined || receiveMemoResult.length <= 0) {
      updateModal(false, 'LastReceivePrint')
      handleAlert('No Receive Found')
    } else {
      setState({ ...state, load: true, generatePDF: true })
      jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
      jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])
      let UnitsTotal = 0
      let GrossAmt = 0
      const todayDate = new Date().toString().split(' ')
      const year = todayDate[3]
      const day = todayDate[2]
      const month = todayDate[1]
        updateData?.forEach((item, i) => {
          item.srNo = i + 1
          // item.TransferByBranch = dFromBranchForPrint
          // item.ReceivedByBranch = strtBrnch.BranchName
          item.ReceivedDate = `${day}-${month}-${year}`
          UnitsTotal += item.Quantity
          GrossAmt += item.NetAmount
        })
        updateData.push({
          srNo: 'Total',
          Quantity: UnitsTotal,
          NetAmount: GrossAmt,
        })
        // selectedPrintData.unshift({
        //   srNo: `Transfer Type : `,
        //   Sender: `Destination City : ${selectedPrintData?.[0]?.ToCity}`,
        //   ReceivedByBranch: `Destination Branch : ${selectedPrintData?.[0]?.DestinationBranchName}`,
        // })
        updateData.unshift({
          srNo: `Destination City : ${updateData?.[0]?.ToCity}`,
          RecName: `Destination Branch : ${updateData?.[0]?.DestinationBranchName}`,
        })

      const columnDefs = [
        {
          headerName: 'Sr. No.',
          exportHead: 'SN',
          field: 'srNo',
          xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'LR No.',
          exportHead: 'LR No.',
          field: 'LRNO',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Dispatch Date',
          exportHead: 'Dispatch Date',
          field: 'BookingDateTime',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Received Date',
          exportHead: 'Received Date',
          field: 'ReceivedDate',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Dispatch By Branch',
          exportHead: 'Dispatch By Branch',
          field: 'BookingBranchName',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Received By Branch',
          exportHead: 'Received By Branch',
          field: 'DestinationBranchName',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Sender Name',
          exportHead: 'Sender Name',
          field: 'Sender',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Receiver Name',
          exportHead: 'Receiver Name',
          field: 'RecName',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Vehicle No',
          exportHead: 'Vehicle No',
          field: 'VehicleNo',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Challan No.',
          exportHead: 'Challan No.',
          field: 'ChallanNo',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Pay. Type',
          exportHead: 'Pay. Type',
          field: 'PaymentType',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Cons. Type',
          exportHead: 'Cons. Type',
          field: 'DescriptionDet',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        {
          headerName: 'Units',
          exportHead: 'Units',
          field: 'Quantity',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
        loginData?.intCompanyID !== RAJESH_TRANSPORT && {
          headerName: 'Gross Amount',
          exportHead: 'Gross Amount',
          field: 'NetAmount',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
        },
      ]
      const pdfColumns = columnDefs.filter(Boolean).map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })

      const doc = new jsPDF({
        unit: 'px',
        compress: true,
        orientation: ReceiveChallanPortrait ? 'p' : 'l',
      })
      doc.autoTableSetDefaults({
        headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
      })

      var totalPagesExp = '{total_pages_count_string}'
      const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
        const doc = data.doc

        // Footer
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.2)
        doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7)
        var str = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(9)
        doc.text(str, 5 + 260, pageHeight - 2)
        doc.setFont('Nirmala', 'normal')
        doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 5, pageHeight - 2)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 5 + 150, pageHeight - 2)
      }

      let drawCell = function (data) {
        var rows = data.table.body
        rows.map((val) => {
          if (Object.keys(val.raw).length == 3) {
            if (val.raw.srNo === 'Total') {
              val.cells[0].colSpan = 12
              val.cells[0].styles.font = 'Nirmala'
              val.cells[0].styles.fontStyle = 'bold'
              val.cells[0].styles.fontSize = '7'
              val.cells[0].styles.fillColor = [208, 220, 238]

              val.cells[12].colSpan = 1
              val.cells[12].styles.font = 'Nirmala'
              val.cells[12].styles.fontStyle = 'bold'
              val.cells[12].styles.fontSize = '7'
              val.cells[12].styles.fillColor = [208, 220, 238]
              if(loginData?.intCompanyID !== RAJESH_TRANSPORT) {
                val.cells[13].colSpan = 1
                val.cells[13].styles.font = 'Nirmala'
                val.cells[13].styles.fontStyle = 'bold'
                val.cells[13].styles.fontSize = '7'
                val.cells[13].styles.fillColor = [208, 220, 238]
              }
            }
          } else if (Object.keys(val.raw).length == 2) {
            val.cells[0].colSpan = 7
            val.cells[0].styles.font = 'Nirmala'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '7'
            val.cells[0].styles.fillColor = [244, 250, 254]
            val.cells[0].styles.halign = 'left'

            val.cells[7].colSpan = 12
            val.cells[7].styles.font = 'Nirmala'
            val.cells[7].styles.fontStyle = 'bold'
            val.cells[7].styles.fontSize = '7'
            val.cells[7].styles.fillColor = [244, 250, 254]
            val.cells[7].styles.halign = 'left'
          }
        })
      }

      doc.setProperties({
        title: `Receive.pdf`,
        subject: 'Receive Summary Report',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Receive',
        creator: 'MTLPL',
      })

      autoTable(doc, {
        margin: { top: 20, left: 5, right: 5, bottom: 5 },
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        columns: pdfColumns,
        body: updateData,
        columnStyles: {
          0: { halign: 'right', fontSize: 7, minCellWidth: 8 },
          1: { fontSize: 7, font: 'Nirmala' },
          2: { fontSize: 7, font: 'Nirmala' },
          3: { fontSize: 7, font: 'Nirmala' },
          4: { fontSize: 7, font: 'Nirmala', minCellWidth: 20 },
          5: { fontSize: 7, font: 'Nirmala', minCellWidth: 20 },
          6: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          7: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          8: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          9: { halign: 'right', fontSize: 7, minCellWidth: 11 },
          10: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          11: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          12: { halign: 'right', fontSize: 7 },
          13: { halign: 'right', fontSize: 7 },
          14: { halign: 'right', fontSize: 7 },
        },
        theme: 'grid',
        headStyles: {
          fillColor: [30, 89, 167],
        },
        didParseCell: (data) => {
          drawCell(data)
        },
        didDrawPage: function (data) {
          doc.setTextColor(40)
          doc.addImage('/images/logo-66.png', 'JPEG', 5, 8, 10, 10)
          doc.setFontSize(12)
          doc.setTextColor(16, 79, 162)
          doc.text('Cargo System | Receive Report', 17, 14)
          doc.setFontSize(10).setFont(undefined, 'bold')
          doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 14,'right')
          jsPdfHeaderFooter(data, loginData, totalPagesExp)
        },
      })
      doc.setFont('Nirmala')

      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('receiveOutput').data = pdfUrl
      }, 2000)
    }
  }
  const receiveClick = (id) => {
    switch (id) {
      case 'Receivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          if ([1,2].includes(LITReceive)) {
            setModal('ReceivedSecond')
          } else {
            updateModal(true, 'Receive')
          }
        }
        break
      case 'ShortReceivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'ShortReceive')
        }
        break
      case 'confirmShortReceive':
        const shortbookingIds = BookingId.join('^').toString()
        const shortDispatchIds = DispatchDetIDs.join('^').toString()
        const shortShortQtyss = shortQtys.join('^').toString()
        const shortObj = {
          strBookingIDs: shortbookingIds,
          strDispatchIDS: shortDispatchIds,
          strShortQtys: shortShortQtyss,
          strComments: Remarks,
        }
        getReceiveShortReceive(loginData, shortObj)
        updateModal(false, 'ShortReceiveSuccess')
        break
      case 'confirmReceive':
        const receivebookingIds = BookingId.join('^').toString()
        const LRno = LrNo.join('^').toString()
        const dispatchId = DipatchIDs.join('^').toString()
        const dispatchDetId = DispatchDetIDs.join('^').toString()
        const shortQtyss = shortQtys.join('^').toString()
        const DamageQtys = damageQtys.join('^').toString()
        if ([1, 2].includes(LITReceive)) {
          const data = {
            strBookingIDs: receivebookingIds,
            strDipatchIDs: dispatchId,
            intNewCityID: loginData.intBranchCityID,
            intNewBranchID: loginData.intBranchID,
            intUserID: loginData.intUserID,
            intCompanyID: loginData.intCompanyID,
            intIsApp: 2,
          }
          PostRequest(urls.getReceiveSecond, data).then((res) => {
            if (res.status === 'Success') {
              setAlert({ show: true, msg: 'LR Received Successfully', success: true, nextId: '' })
            } else {
              setAlert({ show: true, msg: 'LR Received Failed', nextId: '' })
            }
          }).catch((err) => {
            console.log(err)
          }).finally(() => {
            setModal('')
            setReceiveLITLrList([])
          })
        } else {
          // if (showListAll) {
          //   const vehicleGroup = groupData('VehicleID', receiveListData)
            
          //   let disID = selelectedData.map(({ BookingID }) => BookingID)
          //   const vehicleDate = topSelectedData.SelectedVehicle.VehicleWithDetail.split(':')
          //   const dtDate = dateFormatWithInputData(vehicleDate[1].split('-'), 'yyyy-MM-dd')
          //   const body = {
          //     SendingCityID: topSelectedData.DFromCity.CityID,
          //     ReceivedCityID: strtCity.CityID,
          //     SendingBranchID: topSelectedData.DFromBranch.BranchID,
          //     ReceivedBranchID: strtBrnch.BranchID,
          //     CompanyID: loginData.intCompanyID,
          //     VehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
          //     Date: dtDate,
          //     VoucherNo: 0,
          //     // VoucherNo: Number(selectedChallan?.VoucherNo),
          //     ConsignmentTypeID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
          //     VehicleID: topSelectedData.SelectedVehicle.VehicleID,
          //     UserID: loginData.intUserID,
          //     Remarks: Remarks,
          //     IsReceiveAllLrs: receiveListData?.length === selelectedData?.length ? 1 : 0,
          //     ExceptionDispatchIDs: receiveListData
          //       ?.filter((item) => !disID?.includes(item.BookingID))
          //       ?.map((obj) => obj?.DispatchID)
          //       ?.join('^'),
          //     ExceptionDispatchDetIDs: receiveListData
          //       ?.filter((item) => !disID?.includes(item.BookingID))
          //       ?.map((obj) => obj?.DispatchDetID)
          //       ?.join('^'),
          //   }
          //   console.log('showListAll', body,showListAll,receiveListData,selelectedData)
          //   // getReceiveUpdateReceiveAllV2(body)
            
          // } 
          if (showListAll) {
            // selected LR ids
            const selectedIDs = selelectedData.map(x => String(x.BookingID))
            // 🚚 vehicle wise group (using your groupData)
            const vehicleGroup = groupData('VehicleID', receiveListData)
            const bodyArray = []
            Object.values(vehicleGroup).forEach(vehicleItems => {
              if (!vehicleItems?.length) return
              // ❗ unselected LR ids for the vehicle
              const unChecked = vehicleItems.filter(
                lr => !selectedIDs.includes(String(lr.BookingID))
              )
              // exception ids
              const exceptionDispatchIDs = unChecked.map(x => x.DispatchID).join('^')
              const exceptionDispatchDetIDs = unChecked.map(x => x.DispatchDetID).join('^')
              let dtDate = '1999-09-09'
              const vehicleString = vehicleItems[0]?.VehicleNo
              if (vehicleString && vehicleString.includes(':')) {
                const datePart = vehicleString.split(':')[1]?.trim()
                dtDate = dateFormatWithInputData(datePart.split('-'),'yyyy-MM-dd')
              }
              const body = {
                SendingCityID: vehicleItems[0].FromCityID,
                ReceivedCityID: strtCity.CityID,
                SendingBranchID: vehicleItems[0].FromBranchID,
                ReceivedBranchID: strtBrnch.BranchID,
                CompanyID: loginData.intCompanyID,
                VehicleNo: vehicleItems[0].VehicleNo,
                Date: dtDate,
                VoucherNo: 0,
                ConsignmentTypeID:tSecDropData.selectconsignmentType === 'All'? 0: tSecDropData.selectconsignmentType?.ConsignmentSubTypeID,
                VehicleID: vehicleItems[0].VehicleID,
                UserID: loginData.intUserID,
                Remarks: Remarks,
                // ⭐ core logic
                IsReceiveAllLrs: unChecked.length === 0 ? 1 : 0,
                ExceptionDispatchIDs: exceptionDispatchIDs,
                ExceptionDispatchDetIDs: exceptionDispatchDetIDs,
              }
              bodyArray.push(body)
            })
            setInsertReceiveAll([bodyArray, selelectedData])
          } else {
            const group=groupData('FromBranchID', selectedData)
            const arr=[];
            Object.values(group).forEach((item)=>{
              const receivebookingIds = item.map((itm) => itm.BookingID).join('^').toString()
              const LRno = item.map((itm) => itm.LRNO).join('^').toString()
              const dispatchId = item.map((itm) => itm.DispatchID).join('^').toString()
              const dispatchDetId = item.map((itm) => itm.DispatchDetID).join('^').toString()
              const shortQtyss = item.map((itm) => 0).join('^').toString()
              const DamageQtys = item.map((itm) => 0).join('^').toString()
              const receiveObj = {
              strBookingIDs: receivebookingIds,
              intSendingCityID: item[0].FromCityID,
              intReceivedCityID: strtCity.CityID,
              intSendingBranchID: item[0].FromBranchID,
              intReceivedBranchID: strtBrnch.BranchID,
              strVehicleNo: item[0].VehicleNo,
              strRemarks: Remarks,
              VehicleID: item[0].VehicleID,
              strDispatchDetIDs: dispatchDetId,
              strDipatchIDs: dispatchId,
              strLRNos: LRno,
              strShortQtantities: shortQtyss,
              strDamageQtys: DamageQtys,
              strDispatchedVehicleNo: '',
              intCompanyID: loginData.intCompanyID,
              intUserID: loginData.intUserID,
              intIsApp: 2,
            }
            // getReceiveUpdateReceive(loginData, receiveObj)
            arr.push(receiveObj)
            })
            setInsertReceive([arr,selectedData])
          }
          setResetFlag(!resetFlag)
          // setSelectedPrintData(null)
          // setSelectedPrintData(selectedData)
          setState({
            ...state,
            dFromBranchForPrint: topSelectedData?.DFromBranch?.BranchName,
            lastReceivePrint: false,
            load: false,
            generatePDF: false,
          })
          updateModal(false, 'Receive')
        }
        break
      case 'lastReceivePrint':
        printClick()
        break
      default:
        break
    }
  }
  const handleKeyDownConfirm = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "receiveConfirmNo") {
        focusElemnt("receiveConfirmYes")
      } else if (id == "receiveConfirmYes") {
        focusElemnt("receiveConfirmNo")
      }
    } else if (e.keyCode === 39) {
      if (id == "receiveConfirmNo") {
        focusElemnt("receiveConfirmYes")
      } else if (id == "receiveConfirmYes") {
        focusElemnt("receiveConfirmNo")
      }
    }
  }
  const handleKeyDownSuccess = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "receiveSuccessNo") {
        focusElemnt("receiveSuccessYes")
      } else if (id == "receiveSuccessYes") {
        focusElemnt("receiveSuccessNo")
      }
    } else if (e.keyCode == 39) {
      if (id == "receiveSuccessNo") {
        focusElemnt("receiveSuccessYes")
      } else if (id == "receiveSuccessYes") {
        focusElemnt("receiveSuccessNo")
      }
    }
  }
  const ReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              Please confirm you want to dispatch receive consignment/s from {topSelectedData?.DFromBranch?.BranchName} to
              {strtBrnch?.BranchName}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              className="select-lr-btn"
              autoFocus={true}
              // id="deliveryyes"
              id='receiveConfirmYes'
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => receiveClick('confirmReceive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'receiveConfirmYes')}
            >
              YES
            </button>
            <Button
              id='receiveConfirmNo'
              className="select-lr-btn"
              variant="outlined"
              color="error"
              // autoFocus={true}
              onClick={() => updateModal(false, 'Receive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'receiveConfirmNo')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
              NO
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ReceiveSecondModal = () => {
    return (
      <Modal headTxt={`Confirm`} width={'35%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '19px' }}>
            <div>
              {`Please confirm you want to dispatch receive consignment/s for ${
                LITReceive === 1 ? 'Vehicle No. ' + topSelectedData?.SelectedVehicle?.VehicleNo : 'LR No. ' + selectedData?.[0].LRNO
              }`}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer' }}
              onClick={() => receiveClick('confirmReceive')}
            >
              Yes
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => setModal('')}
              style={{ cursor: 'pointer' }}
            >
              No
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Success`} width={load ? '90%' : '25%'} updateModal={()=>{window.location.reload(false)}}>
        <>
          {load ? (
            ''
          ) : (
            <>
              <Stack>
                <Box style={{ margin: '20px', fontSize: '16px' }}>
                  <div>Successfull Receive</div>
                  <div>Do you want Print ?</div>
                </Box>
              </Stack>
              <Stack>
                <div className="modal-btn-grp">
                  <button
                    // autoFocus
                    className="select-lr-btn"
                    id="receiveSuccessYes"
                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '16px' }}
                    onClick={() => { printClick(); focusElemnt('Receive_Dispatch_From_City') }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'receiveSuccessYes')}
                  >
                    YES
                  </button>
                  <Button
                    className="select-lr-btn"
                    variant="outlined"
                    id='receiveSuccessNo'
                    color="error"
                    autoFocus={true}
                    onClick={() => { updateModal(false, 'ReceiveSuccess'); focusElemnt('Receive_Dispatch_From_City');window.location.reload(false); }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'receiveSuccessNo')}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                  >
                    NO
                  </Button>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="receiveOutput"
              type="application/pdf"
              width="1330"
              height="600"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }

  const ShortReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              Please confirm you want to Short Dispatch Receive consignment/s from {topSelectedData.DFromBranch.BranchName} to{' '}
              {strtBrnch.BranchName}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => receiveClick('confirmShortReceive')}
            >
              YES
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => updateModal(false, 'ShortReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
              NO
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ShortReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Success`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '10px', fontSize: '16px' }}>
            <div> Successfull Short Receive of Selected LR</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
              onClick={() => updateModal(false, 'ShortReceiveSuccess')}
            >
              Ok
            </button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const LastReceivePrint = (isRecve = false) => {
    return (
      <Modal headTxt={` Last Receive Print`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>Do you want to Last Receive Print ?</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => receiveClick('lastReceivePrint')}
                >
                  YES
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => updateModal(false, 'LastReceivePrint')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                  NO
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
        {load ? (
          <object
            id="receiveOutput"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Transfer Summary Report"
            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }

  const ReceivedItemList = (isRecve = false) => {
    return (
      <Modal headTxt={` Receive Item List`} width={'95%'} updateModal={updateModal}>
        <Stack>
          <ReceivedItem handleAlert={handleAlert} />
        </Stack>
      </Modal>
    )
  }
  const FilteredTablePreviewModal = () => {
    return (
      <Modal
        headTxt={`Receive Filter Preview`}
        headText2={`${filteredTableRows.length} row(s) from ${filteredTableSource || 'receive table'}`}
        width={'95%'}
        updateModal={updateModal}
      >
        <>
          {filteredPreviewGeneratePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          <Stack direction="row" spacing={2} style={{ padding: '12px 16px 0 16px', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '13px', fontWeight: 'bold', marginBottom:'10px' }}
              onClick={() => generateFilteredTablePreviewPdf(true)}
              disabled={!filteredTableRows?.length || filteredPreviewGeneratePDF}
            >
              Download PDF
            </Button>
          </Stack>
          {filteredPreviewPdfUrl ? (
            <object
              id="receiveFilteredPreviewOutput"
              type="application/pdf"
              width="100%"
              height="650"
              data={filteredPreviewPdfUrl}
              title="MTLPL - Cargo System - Receive Filter Preview"
              aria-label="MTLPL - Cargo System - Receive Filter Preview"
            ></object>
          ) : (
            <div style={{ padding: '24px', minHeight: '200px' }}>
              {filteredPreviewGeneratePDF ? '' : 'Preparing preview...'}
            </div>
          )}
        </>
      </Modal>
    )
  }
  const onKeyDown = (id, e) => {
    switch (id) {
      case 'ReceiveBtn':
        if (e.key === 'Enter') {
        } else if (e.key === 'Escape') {
          focusElemnt('receiveRemarks')
        }
        break
      case 'remarks':
        if (e.key === 'Enter') {
          focusElemnt('Receivebtn')
        } else if (e.key === 'Escape') {
          focusElemnt('receiveShowList')
        }
        break
      default:
        break
    }
  }
  return (
    <>
      <div className="bottom-section" style={{ width: '100%' }}>
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              sx={{
                width: '2px',
                margin: '0px -16px 0px 0px !important',
                //   backgroundColor: "#0086ff",
                backgroundColor: '#DDD',
              }}
              flexItem
            />
          }
          spacing={2}
          sx={{ background: '#f0fcf4', width: '100%' }}
        >
          <Item sx={{ width: '30%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    id="receiveRemarks"
                    type="text"
                    name={'SenGstnNo'}
                    label={`Remarks`}
                    value={Remarks}
                    onChange={(e) => setState({ ...state, Remarks: e.target.value })}
                    // disabled={true}
                    // onKeyDown={(e) => onKeyDown('remarks', e)}
                    onKeyDown={(e) => navigation3(e, 'Receivebtn', 'checkbox_0', () => {})}
                  />
                </div>
              </Item>
            </Box>
          </Item>
          <Item sx={{ width: '70%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                padding: '0% 10px',
                // marginTop: "15px",
                background: '#f0fcf4',
              }}
            >
              {[JAIN_NEW, JAIN_COMPANY_ID].includes(loginData.intCompanyID) ? (
                <></>
              ) : (
                <>
                  {loginData.intCompanyID === GUJRAT_COMPANY_ID && (
                    <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                      <Button
                        variant="outlined"
                        sx={{ width: '100%' }}
                        style={{
                          borderColor: filteredTableRows?.length ? '#fe5200' : '#cccccc',
                          color: filteredTableRows?.length ? '#fe5200' : '#000',
                          fontSize: '15px',
                          fontWeight: 'bold',
                          textTransform: 'Uppercase',
                        }}
                        onClick={() => {
                          if (!filteredTableRows?.length) {
                            handleAlert('No filtered receive rows found')
                            return
                          }
                          setFilteredPreviewPdfUrl('')
                          setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: true }))
                          updateModal(true, 'FilteredTablePreview')
                        }}
                        disabled={!filteredTableRows?.length}
                      >
                        Print
                      </Button>
                    </Item>
                  )}
                  <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                      onClick={() => updateModal(true, 'ReceivedItemList')}
                    >
                      Received Item Lists
                    </Button>
                  </Item>
                </>
              )}
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => {
                    setState({ ...state, load: false, generatePDF: false, lastReceivePrint: true })
                    updateModal(true, 'LastReceivePrint')
                  }}
                >
                  Last Receive Print
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{
                    borderColor: [1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? '#cccccc' : '#fe5200',
                    color: [1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? '#000' : '#fe5200',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    textTransform: 'Uppercase',
                  }}
                  onClick={() => receiveClick('ShortReceivebtn')}
                  disabled={[1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? true : false}
                >
                  Short Receive
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="contained"
                  id="Receivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  onClick={() => receiveClick('Receivebtn')}
                  onKeyDown={(e) => navigation3(e, 'Receive_Dispatch_From_City', 'receiveRemarks', () => {})}
                >
                  Receive
                </Button>
              </Item>
            </Box>
          </Item>
        </Stack>
      </div>
      {showModal && [successModal.Receive.id].includes(modalType) && ReceiveModal(successModal.Receive.id)}
      {'ReceivedSecond' === modal && ReceiveSecondModal()}
      {receivePrintPopup && ReceiveSuccessModal()}
      {showModal && [successModal.ShortReceive.id].includes(modalType) && ShortReceiveModal(successModal.ShortReceive.id)}
      {showModal && [successModal.LastReceivePrint.id].includes(modalType) && LastReceivePrint(successModal.LastReceivePrint.id)}
      {showModal && [successModal.ReceivedItemList.id].includes(modalType) && ReceivedItemList(successModal.ReceivedItemList.id)}
      {showModal && 'FilteredTablePreview'===modalType && FilteredTablePreviewModal()}
      {showModal &&
        [successModal.ShortReceiveSuccess.id].includes(modalType) &&
        ShortReceiveSuccessModal(successModal.ShortReceiveSuccess.id)}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getReceiveUpdateReceive,
  getReceiveShortReceive,
  getUpdateReceiveSecond,
  getReceiveLastReceivePrint,
  getReceiveUpdateReceiveAllV2
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveBottomSection)
